import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class propsMixin extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly active!: boolean;

  @Prop({ type: String, default: '' })
  readonly bgColor!: string;

  @Prop({ type: Boolean, default: false })
  readonly isNoDate!: boolean;
}



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/selector/components/propsMixim.ts